import { render, staticRenderFns } from "./AccesskeyLink.vue?vue&type=template&id=6fa2b65e&scoped=true&"
import script from "./AccesskeyLink.vue?vue&type=script&lang=js&"
export * from "./AccesskeyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2b65e",
  null
  
)

export default component.exports